import { render, staticRenderFns } from "./ChangeNoticeDetail.vue?vue&type=template&id=bd49c98a&scoped=true&"
import script from "./ChangeNoticeDetail.vue?vue&type=script&lang=js&"
export * from "./ChangeNoticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeNoticeDetail.vue?vue&type=style&index=0&id=bd49c98a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd49c98a",
  null
  
)

export default component.exports